const picklistMetadataClasses: Map<string, object> = new Map();

export default function PicklistMetadataClassFactory(name: string): object | undefined{
    return picklistMetadataClasses.get(name + "PicklistMetadata");
}